import { h as o } from "vue";
import t from "./design-system.es330.js";
import n from "./design-system.es331.js";
const c = {
  name: "DsTooltip",
  props: {
    /**
     * Boolean to render legacy version of tooltip
     */
    legacy: Boolean
  },
  setup(f, { slots: e, attrs: r }) {
    return () => f.legacy ? o(t, r, e) : e.reference ? o(n, r, {
      default: e.reference,
      content: e.default
    }) : o(n, r, e);
  }
};
export {
  c as default
};
//# sourceMappingURL=design-system.es113.js.map
